import { useApiClient } from '~/api-client';
import { useEffect } from 'react';
import { autorun } from 'mobx';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { useBroadcast } from '../../common/broadcast-channel/use-broadcast';
import { useDexResults } from './use-dex-results';
import { useMutation } from '@tanstack/react-query';
import { LatestSeenDexIncomingMessageResource } from '@mark43/cad-api';
import { useApplicationType } from '../../common/hooks/use-application-type';

export function DexNotificationsDismisser(): React.ReactElement {
    const apiClient = useApiClient();
    const { isFirstResponder } = useApplicationType();
    const panel = useWorkspacePanel(isFirstResponder);
    const { dexResultsStore } = useDexResults();
    const { postMessage } = useBroadcast('dex-results');
    const latestSeenDexIncomingMessageMutation = useMutation((incomingMessageId: number) => {
        return apiClient.request<LatestSeenDexIncomingMessageResource.UpdateLatestSeenDexIncomingMessageForUser>(
            {
                method: 'POST',
                url: 'latest_seen_dex_incoming_message',
                data: {
                    incomingMessageId,
                },
            }
        );
    });

    useEffect(() => {
        return autorun(() => {
            if (
                (isFirstResponder || panel.isFocused) &&
                dexResultsStore.notificationCount > 0 &&
                dexResultsStore.latestStoredDexIncomingMessageId
            ) {
                postMessage({
                    type: 'DISMISS_DEX_NOTIFICATIONS',
                    payload: {
                        latestSeenDexIncomingMessageId:
                            dexResultsStore.latestStoredDexIncomingMessageId,
                    },
                });
                latestSeenDexIncomingMessageMutation.mutate(
                    dexResultsStore.latestStoredDexIncomingMessageId
                );
            }
        });
    }, [
        dexResultsStore,
        panel,
        postMessage,
        latestSeenDexIncomingMessageMutation,
        isFirstResponder,
    ]);
    return <></>;
}
